// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"483":"ed7eb0f0","923":"b81cfae3"}[chunkId] + ".chunk.css";
};